import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getTenantFirebaseConfig, getCurrentTenant } from './tenantConfig';

// Obtener configuración
const firebaseConfig = getTenantFirebaseConfig();
const currentTenant = getCurrentTenant();

// Validar configuración
const requiredConfig = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId,
};

// Verificar que todas las variables estén definidas
const missingVars = Object.entries(requiredConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingVars.length > 0) {
  console.error('🚨 Firebase: Configuración faltante:', missingVars);
  throw new Error(`Configuración faltante para Firebase: ${missingVars.join(', ')}`);
}

// Initialize default Firebase app
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Inicializar Firestore con persistencia offline nativa multi-tab
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const functions = getFunctions(app);

// Initialize Firebase Cloud Messaging (solo si está soportado)
export const messaging = isSupported().then((supported) => {
  if (supported) {
    return getMessaging(app);
  }
  return null;
});

// Exportar información del tenant (por compatibilidad)
export { currentTenant };

export default app;